import { useEffect, memo } from 'react'
import { useRouter } from 'next/router'
import { scroller } from 'react-scroll'
import PropTypes from 'prop-types'

import NavigationBar from '@/components/NavigationBar'
import Footer from '@/components/Footer'

import Blog from '@/features/landing/templates/Blog'
import Contact from '@/features/landing/templates/Contact'
import FAQ from '@/features/landing/templates/FAQ'
import TopPane from '@/features/landing/templates/TopPane'
import WhatInProKit from '@/features/landing/templates/WhatInProKit'
import WhatProKit from '@/features/landing/templates/WhatProKit'
import WhyProKit from '@/features/landing/templates/WhyProKit'
// import Promotion from '@/features/landing/templates/Promotion'
import PromotionBanner from '@/features/landing/templates/PromotionBanner'
import SiteReference from '@/features/landing/templates/SiteReference'
import Certified from '@/features/landing/templates/Certified'
import OtherProducts from '@/features/landing/templates/OtherProducts'

import {
  contactRoute,
  whatIsProKitRoute,
  whyProKitRoute,
  serviceRoute,
  documentsRoute,
  blogRoute,
} from '@/routes'

import * as LandingPageData from '@/features/landing/constants'
import { BlogPropType } from '@/propTypes'
import { ReactComponent as Logo } from '@/svg/logo_logo.svg'

import Container from './style'
import { useHooks } from './methods'

import env from '@/lib/env'
import { SCROLL_OPTION } from '@/lib/scroll'

export interface Props {
  blogList: BlogInterface[]
}

function LandingPage({ blogList = [] }: Props): React.ReactElement {
  const { handleContactSubmit } = useHooks()

  const { asPath } = useRouter()

  useEffect(() => {
    const splitedAsPath = asPath.split('#')

    if (splitedAsPath.length < 2) return

    const hash = splitedAsPath[splitedAsPath.length - 1]

    setTimeout(() => {
      scroller.scrollTo(hash, SCROLL_OPTION)
    }, 500)
  }, [])

  return (
    <Container id="main">
      <NavigationBar />
      <TopPane id="top" />
      <SiteReference />
      <PromotionBanner
        id="banner"
        imageSrc={`${env.BASE_PATH}/static/images/promotions/version-2.webp`}
      />
      <WhatProKit id={whatIsProKitRoute.hash}>
        {LandingPageData.whatIsProKit.items}
      </WhatProKit>
      <WhyProKit
        id={whyProKitRoute.hash}
        items={LandingPageData.whyProKit.items}
      />
      <WhatInProKit
        widgetId={serviceRoute.hash}
        documentId={documentsRoute.hash}
        items={LandingPageData.whatInProKit.items}
        documents={LandingPageData.documents.items}
        documentsLink={LandingPageData.documents.allDocumentLink}
      />
      {/* <Promotion /> */}
      <FAQ items={LandingPageData.faq.items} />
      <Certified />
      <OtherProducts />
      <Blog
        id={blogRoute.hash}
        items={blogList}
        blogLink={LandingPageData.blog.allBlogLink}
      />
      <Contact
        id={contactRoute.hash}
        logo={<Logo />}
        company={LandingPageData.contact.company}
        address={LandingPageData.contact.address}
        tel={LandingPageData.contact.tel}
        email={LandingPageData.contact.email}
        facebook={LandingPageData.contact.facebook}
        linkedIn={LandingPageData.contact.linkedIn}
        medium={LandingPageData.contact.medium}
        onSubmit={handleContactSubmit}
      />
      <Footer />
    </Container>
  )
}

LandingPage.propTypes = {
  blogList: PropTypes.arrayOf(BlogPropType),
}

export default memo(LandingPage)
